module.exports = __webpack_public_path__ + "img/hk.747eb8df.png";